export default __webpack_public_path__ + "static/media/screenshot1_sm.f1171dd5.jpg";